<template>
  <div
    class="avatars block"
    :style="`width: ${ width }px; min-width: ${ width }px;
      height: ${+(size ? size : 32 ) + 4}px`">
    <template v-for="(user, n) in items">
      <UserIcon
        v-if="user"
        :key="n"
        class="avatars"
        :name="user.fullName || user.fio"
        :size="size || 32"
        :src="user.avatar"
        :style="`z-index: ${n}; left: ${n* 10}px;`"/>
    </template>
    <v-avatar
      v-if="people && items.length < people.length"
      color="main__green user-avatar white--text"
      :height="`${size || 32}px`"
      :min-width="`${size || 32}px`"
      :style="`z-index: 6; left: 20px`"
      :title="names"
      :width="`${size || 32}px`">
      + {{ people.length - 2 }}
    </v-avatar>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'

export default {
  name: 'avatarsBlock',
  props: {
    people: Array,
    size: [String, Number]
  },
  computed: {
    names() {
      return this.people?.slice(0,-2).map(el => el.fullName || el.fio).join(', ')
    },
    items() {
      if (!this.people?.length) {
        return []
      }
      let people = this.$_.cloneDeep(this.people)

      if (this.people[0].hasOwnProperty('user')) {
        people = people.map(i => i.user)
      }
      if (people.length > 3) {
        return people.reverse().slice(-2)
      } else {
        return people.reverse()
      }
    },
    width() {
      let size = this.size ? +this.size : 32
      return Math.round(this.people?.length || 0 > 3 ?
        size + 3 * (size / 3) :
        size + ((this.items.length || 0 - 1 ) * (size / 3)))
    }
  },
  components: {
    UserIcon,
  }
}
</script>
